import { createPortal } from 'react-dom'

import Select from 'react-select'
import { Modal } from 'react-bootstrap'
import { KTSVG } from '_metronic/helpers'

interface Props {
  isOpen: boolean
  handleClose: () => void
}

const AssetRequestForm: React.FC<Props> = ({ isOpen, handleClose }) => {
  const modalsRoot = document.getElementById('root-modals') || document.body

  return createPortal(
    <Modal
      id='kt_modal_asset_request_form'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-900px'
      show={isOpen}
      onHide={handleClose}
      backdrop={true}>
      <div className='modal-content'>
        <div className='modal-header'>
          <h2>เพิ่มทรัพยากร</h2>
          {/* begin::Close */}
          <div className='btn btn-sm btn-icon btn-active-light-danger' onClick={handleClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/general/gen040.svg' />
          </div>
          {/* end::Close */}
        </div>

        <div className='modal-body py-lg-10 px-lg-10 min-h-100px'>
          <div className='mb-5'>
            <label htmlFor='name' className='form-label'>
              ชื่ออุปกรณ์
            </label>
            <input className='form-control form-control-sm' />
          </div>

          <div className='mb-5'>
            <label htmlFor='type' className='form-label'>
              ประเภทของอุปกรณ์
            </label>
            <Select
              id='type'
              options={[
                {
                  label: 'เครื่องจักร',
                  value: 'machine',
                },
                {
                  label: 'อุปกรณ์',
                  value: 'equipment',
                },
                {
                  label: 'อื่นๆ',
                  value: 'other',
                },
              ]}
              styles={{
                control: (provided: any) => ({
                  ...provided,
                  minHeight: 0,
                  fontSize: '0.95rem',
                  border: '1px solid #e1e3ea',
                }),
              }}
            />
          </div>

          <div className='mb-5'>
            <label htmlFor='name' className='form-label'>
              หน่วยของอุปกรณ์
            </label>
            <input className='form-control form-control-sm' />
          </div>
        </div>

        <div className='modal-footer'>
          <button className='btn btn-light fw-bold' onClick={handleClose}>
            ยกเลิก
          </button>
          <button className='btn btn-primary fw-bold' onClick={handleClose}>
            บันทึก
          </button>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export default AssetRequestForm
